var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72969 4.58013L7.05998 1.91041L4.39027 4.58013L3.68506 3.87492L7.05998 0.5L10.4349 3.87492L9.72969 4.58013Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5564 1.20508H7.56384V11.7832H6.5564V1.20508Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0973 17.8276H2.02288C1.16655 17.8276 0.511719 17.1727 0.511719 16.3164V7.24944C0.511719 6.39312 1.16655 5.73828 2.02288 5.73828H5.54892V6.74572H2.02288C1.72065 6.74572 1.51916 6.94721 1.51916 7.24944V16.3164C1.51916 16.6186 1.72065 16.8201 2.02288 16.8201H12.0973C12.3995 16.8201 12.601 16.6186 12.601 16.3164V7.24944C12.601 6.94721 12.3995 6.74572 12.0973 6.74572H8.57123V5.73828H12.0973C12.9536 5.73828 13.6084 6.39312 13.6084 7.24944V16.3164C13.6084 17.1727 12.9536 17.8276 12.0973 17.8276Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.801e046d23890c35e874886f69972fbb.svg";
export { ForwardRef as ReactComponent };